<div [ngClass]="'page-'+(isDesigner ? 'edit' : 'preview')">

  <div *ngIf="isDesigner; else isNotDesigner" tabindex="0" class="panel" [formGroup]="formGroup"
    (mousedown)="onShowConfiguration($event, configurationType.Page, page)"
    (keydown)="handleKey($event, configurationType.Page, page)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
  <ng-template #isNotDesigner>
    <div class="panel" [formGroup]="formGroup">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="content">

      <div class="title" *ngIf="!page.hideTitle">
        {{page.title}}
      </div>

      <div class="flex flex-wrap gap-2 w-full">
        <ng-container *ngFor="let row of page.controlRows">
          <div class="page-row">

            @if(fc.userData){
              <!--TODO: Esto es la informacion del usario, hay que cambiar esto para que sea dinamico, se crea un control para el lable y se crean variables para el sistema-->
              <div class="bg-gray-100 border-round-2xl w-full grid my-3 px-4 mx-1 ">
                <div class="w-full sm:w-12 md:w-12 lg:w-12 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full pt-3 pb-0">
                        <h2 class="my-0 font-18 font-principal uppercase font-medium title-blue ">Informacion del Usuario</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Nombre completo</label>
                        <p class="details-text">{{ fc.userData.nombreCompleto }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Tipo de Identificación</label>
                        <p class="details-text">{{ fc.userData.tipoIdentificacion }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Identificación</label>
                        <p class="details-text">{{ fc.userData.identificacion }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Correo</label>
                        <p class="details-text">{{ fc.userData.correo }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Teléfono</label>
                        <p class="details-text">{{ fc.userData.telefono }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-12 md:w-6 lg:w-4 p-1">
                  <div class="control-preview">
                    <div class="content">
                      <div class="flex flex-column w-full">
                        <label class="control-label">Dirección</label>
                        <p class="details-text">{{ fc.userData.direccion }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <ng-container *ngFor="let control of row">
              <app-form-section-control [page]="page" [control]="control" [pageFormGroup]="formGroup"
                [isDesigner]="isDesigner"
                class="p-1"  [ngClass]="'w-full sm:'+ control.widthSmallScreen + ' md:' + control.widthMediumScreen + ' lg:' + control.widthLargeScreen + ' xl:' + control.widthLargerScreen">
              </app-form-section-control>
            </ng-container>

          </div>
        </ng-container>
      </div>

    </div>
    <div class="footer">

      <p-splitButton *ngIf="isDesigner" outlined severity="primary"
        [label]="'dynamic-form.builder.agregar-campo' | translate" icon="pi pi-plus" 
        class="p-button-sm w-full" [appendTo]="'body'"
        (onClick)="onCreateNewControl(undefined, pageIndex)"
        [model]="VisibleControls" />

      <button pButton type="button" *ngIf="isDesigner" [label]="'dynamic-form.builder.borrar-Pagina' | translate" icon="pi pi-trash"
        class="p-button-sm p-button-danger w-full p-button-outlined" (click)="onDeletePage(pageIndex)"></button>
    </div>
  </ng-template>
</div>
